import { createFileRoute, notFound } from "@tanstack/react-router";
import { parseLang } from "@majourneys/shared";
import { transferRoutesQueryOptions } from "../../../features/transport/api/transfers.api";
import { parseRideSearch, TRANSPORT_CITY, type RideSearch } from "../../../features/transport/lib/routes";
import { TransportRidePage } from "../../../features/transport/pages/transport-ride-page";

// One transfer ride: `/$lang/transport/<route slug>`. Not nested under the
// hub (the trailing underscore), so the hub page has no <Outlet /> to carry.
// `?people=<n>` comes from the hub's quote bar and opens the form on it.
export const Route = createFileRoute("/$lang/_layout/transport_/$slug")({
  validateSearch: (search: Record<string, unknown>): RideSearch => parseRideSearch(search),
  // The same query as the hub, so both pages share one cached list and the
  // form, the prices and the SEO head are all in the server HTML.
  loader: async ({ context, params }) => {
    const routes = await context.queryClient.ensureQueryData(
      transferRoutesQueryOptions(TRANSPORT_CITY, parseLang(params.lang)),
    );
    if (!routes.some((r) => r.slug === params.slug)) throw notFound();
    return null;
  },
  component: TransportRidePage,
});
